import {motion} from 'framer-motion';
import ButtonLink from "../components/shared/ButtonLink";
import Card from '../components/shared/Card';

function Login() {
  return (
    <motion.div
      className="normalContainer"
      initial={{x: -1000, y: 1000, opacity: 0}}
      animate={{x: 0, y: 0, opacity: 1}}
      exit={{x: -1000, y: 1000, opacity: 0, scale: 1}}
      transition={{duration: 1}}>
        <Card delayTime={1}>
          <h1>Login</h1>
          <ButtonLink redirect='/'>Ir a Index</ButtonLink>
        </Card>
    </motion.div>
  )
}

export default Login